import React from "react";
import Aux from "../src/hoc/_Aux";
import { BActionButton } from "./App/components";
import cpayLogo from "../src/assets/images/cpay-logo.svg";
import { useHistory } from "react-router-dom";

const Fallback = () => {
    const history = useHistory();
    return (
        <Aux>
            <div className="auth-wrapper offline">
                <div className="text-center">
                    <img src={cpayLogo} alt="corporatePay logo" className={"img-fluid"} />
                    <h5 className="text-muted mb-1 mt-3">
                        Bad Client Request, Please Try After Some Time {" "}
                    </h5>
                    <h5 className="text-muted mb-4">Or Contact Support </h5>
                    <div style={{ display: "flex", justifyContent: "center" }}>
                        <BActionButton
                            style={{ width: "50%" }}
                            title={
                                <>
                                    <i className="feather icon-home" />
                                    Back to Home
                                </>
                            }
                            onClick={() => history.goBack()}
                        />
                    </div>
                </div>
            </div>
        </Aux>
    );
};

export default Fallback;
